import React, { useContext } from 'react'
import { StyleSheet, Text, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import {
  fontColorWhite, shadowWhiteTxt,
  bigFontPc, bigFontSp, fontPc, fontSp,
} from '../../../../../style/css/CmnStyle';
import { hpContext } from '../../../HPContext';
import FadeinWrap from '../../../../common/animation/FadeinWrap';
import GradationWrap from '../../../../common/wrap/GradationWrap';

function HpContentWorry(props) {
  const { t, i18n } = useTranslation();

  const isWide = useContext(hpContext).isWide;

  const windowDimensions = useContext(hpContext).windowDimensions;
  const windowWidth = windowDimensions.width;
  const windowHeight = windowDimensions.height;


  const styles = StyleSheet.create({
    container: {
      paddingTop: windowHeight*0.1,
      paddingBottom: isWide? windowHeight*0.1 : 0,
      paddingHorizontal: isWide? windowWidth*0.2 : 15,
    },
    title: {
      color: fontColorWhite,
      fontSize: isWide? bigFontPc : bigFontSp,
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: isWide? 50 : 25,
    },
    content: {
      color: fontColorWhite,
      fontSize: isWide? fontPc : fontSp,
      textAlign: 'left',
    },

    sepComp: {
      transform: isWide? 'skewY(5deg)' : 'skewY(15deg)',
      paddingVertical: 50,
      marginTop: isWide? '-10%' : '-80%',
      zIndex: -1,
    },
    sep: {
      height: isWide? windowHeight*0.25 : windowHeight*0.5,
    },
  });



  return (
    <FadeinWrap loop={true}>
      <GradationWrap>
        <View style={styles.container}>
          <Text style={[shadowWhiteTxt, styles.title]}>
            {t('top.description.title1Short1')}
            {!isWide && <>{`\n`}</>}
            {t('top.description.title1Short2')}
          </Text>
          <Text style={[shadowWhiteTxt, styles.content]}>
            {t('top.description.content1')}
          </Text>
        </View>
      </GradationWrap>

      <View style={styles.sepComp}>
        <GradationWrap>
          <View style={styles.sep}></View>
        </GradationWrap>
      </View>
    </FadeinWrap>
  );
}


export default HpContentWorry;